<template>
	<div
		class="flex flex-col lg:flex-row"
		:class="[
			imageOnRight ? '' : 'lg:flex-row-reverse',
			imageOnTop ? 'flex-col-reverse' : '',
			gapX,
		]"
	>
		<div
			:class="[
				contentColumnWidth,
				contentColumnPadding,
				contentColumnClass,
			]"
		>
			<slot name="content"></slot>
		</div>
		<div
			class="flex justify-center"
			:class="[
				imageColumnWidth,
				imageColumnPadding,
				imageVerticalAlign,
				imageColumnClass,
			]"
		>
			<div class="w-full">
				<slot name="image"></slot>
			</div>
		</div>
	</div>
</template>

<script setup>
const props = defineProps({
	contentColumnWidth: {
		type: String,
		default: 'w-full lg:w-1/2',
		required: false,
	},
	imageColumnWidth: {
		type: String,
		default: 'w-full lg:w-1/2',
		required: false,
	},
	imageVerticalAlign: {
		type: String,
		default: 'items-center',
		required: false,
	},
	imageOnRight: {
		type: Boolean,
		default: true,
		required: false,
	},
	imageOnTop: {
		type: Boolean,
		default: false,
		required: false,
	},
	gapX: {
		type: String,
		default: '',
		required: false,
	},
	contentColumnPadding: {
		type: String,
		default: 'lg:pr-10',
		required: false,
	},
	imageColumnPadding: {
		type: String,
		default: 'lg:pl-10',
		required: false,
	},
	contentColumnClass: {
		type: String,
		default: '',
		required: false,
	},
	imageColumnClass: {
		type: String,
		default: '',
		required: false,
	},
})
</script>
